export default __webpack_public_path__ + "static/media/regulatory--weight-limit--g7.11b45bd0.png";